var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#338808"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.875 55.375C39.125 55.75 39.5 55.875 40 55.875C40.4375 55.875 40.8125 55.75 41.125 55.375L59.5625 37C59.8125 36.75 60 36.375 60 35.875C60 35.4375 59.8125 35.0625 59.5625 34.75L57.25 32.5C56.9375 32.1875 56.5625 32 56.125 32C55.6875 32 55.3125 32.1875 55 32.5L40 47.5L33 40.5C32.625 40.1875 32.25 40 31.8125 40C31.375 40 31 40.1875 30.75 40.5L28.4375 42.75C28.125 43.0625 28 43.4375 28 43.875C28 44.375 28.125 44.75 28.4375 45L38.875 55.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7350381aea699cd30afcf022df475dd1.svg";
export { ForwardRef as ReactComponent };